import toString from 'lodash/toString';
import isEmpty from 'lodash/isEmpty';
import replace from 'lodash/replace';

const valid = (value, regex, message) => ({
  result: regex instanceof RegExp ? regex.test(value) : !!value,
  errorMessage: message
});

export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const trimRegex = /^\S*$/;
export const phoneRegex = /^[1]([3-9])[0-9]{9}$/;
export const mobileRegex = /(^(0\d{2,3}-\d{7,8}|\(?0\d{2,3}[)-]?\d{7,8}|\(?0\d{2,3}[)-]*\d{7,8})$)|(^\d{4}$)|(^\d{5}$)|(^\d{7}$)|(^\d{8}$)/;
export const cardNumberRegex = /^([1-9]{1})(\d{14}|\d{18})$/;
export const postcodeRegex = /^[1-9][0-9]{5}$/;
export const ipRegex = /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){6}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^::([\da-fA-F]{1,4}:){0,4}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:):([\da-fA-F]{1,4}:){0,3}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){2}:([\da-fA-F]{1,4}:){0,2}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){3}:([\da-fA-F]{1,4}:){0,1}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){4}:((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$|^:((:[\da-fA-F]{1,4}){1,6}|:)$|^[\da-fA-F]{1,4}:((:[\da-fA-F]{1,4}){1,5}|:)$|^([\da-fA-F]{1,4}:){2}((:[\da-fA-F]{1,4}){1,4}|:)$|^([\da-fA-F]{1,4}:){3}((:[\da-fA-F]{1,4}){1,3}|:)$|^([\da-fA-F]{1,4}:){4}((:[\da-fA-F]{1,4}){1,2}|:)$|^([\da-fA-F]{1,4}:){5}:([\da-fA-F]{1,4})?$|^([\da-fA-F]{1,4}:){6}:$/;
export const positiveIntegerRegex = /(^[1-9]\d*$)/;
// 最多两位小数
export const twoDecimalPlaceRegex = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/;
export const hundredRegex = /^([1-9][0-9]{0,1}|100)$/;
// 大写字母、小写字母、数字、特殊字符 四选三,长度大于8
export const passwordRegex = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z._~!@#$^&*]+$)(?![a-z0-9]+$)(?![a-z._~!@#$^&*]+$)(?![0-9._~!@#$^&*]+$)[a-zA-Z0-9._~!@#$^&*]{8,}$/;

export const rules = {
  validateRequest: text => {
    if (text) {
      const newText = String(text).replace(/\r\n/g, '').replace(/\n/g, '').replace(/\s/g, '');
      if (newText.length < 0) {
        return valid(newText, null, '必填项');
      }
    }
    return {
      result: true,
      errorMessage: ''
    };
  },
  validateEmail: email => {
    const regex = emailRegex;
    if (!email) {
      return {
        result: true
      };
    }
    return valid(email, regex, '邮箱地址格式不正确');
  },
  validateTrim: str => {
    const regex = trimRegex;
    return valid(str, regex, '不能包含空格');
  },
  clearTrim: value => {
    const str = toString(value);
    return String(str) ? str.replace(/\s+/g, '') : '';
  },
  validatePhoneOrMobile: number => {
    if (number) {
      const result = phoneRegex.test(number) || mobileRegex.test(number);
      return valid(result, null, '手机或电话号格式不正确');
    }
    return {
      result: true,
      errorMessage: ''
    };
  },
  validatePhone: number => {
    if (number) {
      const result = phoneRegex.test(number);
      return valid(result, null, '手机号格式不正确');
    }
    return {
      result: true,
      errorMessage: ''
    };
  },
  validateMobile: number => {
    if (number) {
      const result = mobileRegex.test(number);
      return valid(result, null, '座机号格式不正确');
    }
    return {
      result: true,
      errorMessage: ''
    };
  },
  validateCardNumber: number => {
    if (number) {
      const result = cardNumberRegex.test(number);
      return valid(result, null, '银行账号格式不正确');
    }
    return {
      result: true,
      errorMessage: ''
    };
  },
  validatePostcode: number => {
    if (number) {
      const result = postcodeRegex.test(number);
      return valid(result, null, '邮编格式不正确');
    }
    return {
      result: true,
      errorMessage: ''
    };
  },
  validateIp: number => {
    if (number) {
      const result = ipRegex.test(number);
      return valid(result, null, 'IP格式不正确');
    }
    return {
      result: true,
      errorMessage: ''
    };
  },
  validatePositiveInteger: number => {
    if (number) {
      const result = positiveIntegerRegex.test(number);
      return valid(result, null, '请输入正整数');
    }
    return {
      result: true,
      errorMessage: ''
    };
  },
  validateTwoDecimalPlace: number => {
    if (number) {
      const result = twoDecimalPlaceRegex.test(number);
      return valid(result, null, '请输入数字（最多保留两位小数）');
    }
    return {
      result: true,
      errorMessage: ''
    };
  },
  validateHundred: number => {
    if (number) {
      const result = hundredRegex.test(number);
      return valid(result, null, '请输入1-100的整数');
    }
    return {
      result: true,
      errorMessage: ''
    };
  },
  validatePassword: password => {
    if (password) {
      const result = passwordRegex.test(password);
      return valid(result, null, '密码须含大小写字母、数字和特殊字符中的三种，且长度不小于8位');
    }
    return {
      result: true,
      errorMessage: ''
    };
  },
  maxLength: (s = '', length = 0) => {
    const maxLength = Number(length);
    const string = String(s);
    const t = string.replace(/[\u4e00-\u9fa5]/g, '');
    const result = (string.length - t.length) * 2 + t.length < maxLength;
    return {
      result,
      errorMessage: result ? '' : `长度不允许超过${maxLength}个字符，注：中文占两个字符`
    };
  }
};

export function validateRule(required = true, validateFn, trigger = ['change', 'blur'], nullMessage = '必填项') {
  const rule = {
    required: !!required,
    trigger
  };
  let check = 'function';
  let params = [];
  if (typeof validateFn !== 'function') {
    if (validateFn) {
      const regex = /(\(=?)(.+)(?=\))/;
      if ((validateFn.match(regex) || []).length > 2) {
        params = validateFn.match(regex)[2].split(',');
        const fn = replace(validateFn, `(${validateFn.match(regex)[2]})`, '');
        check = rules[fn];
      } else {
        check = rules[validateFn];
      }
    } else if (required) {
      check = rules['validateRequest'];
    } else {
      check = null;
    }
  }
  if (check) {
    rule.validator = (rule, value, callback) => {
      const { result, errorMessage } = check(value, ...params);
      if (required) {
        if (!value || !rules.clearTrim(value) || isEmpty(String(value))) {
          return callback(nullMessage);
        }
      }
      return result ? callback() : callback(new Error(errorMessage));
    };
  } else {
    rule.message = nullMessage;
  }
  return rule;
}



// WEBPACK FOOTER //
// ./src/utils/validator.js